module.exports = __webpack_public_path__ + "static/media/sound.9ff09614.svg";